
import { UnstakeListBox } from "components/staked-asset-page/UnstakeListBox";
import { MsgExecuteContract } from "@goblinhunt/cosmes/client";
import { ConfigResponse } from "models/staking/ConfigResponse";
import { RewardResponse } from "models/staking/RewardResponse";
import { UnstakeResponse } from "models/staking/UnstakeResponse";
import { useAsset } from "provider/AssetProvider"
import { useWallet } from "provider/WalletProvider";
import { SetStateAction, useCallback, useEffect, useState } from "react"
import { CLASSIC_CHAIN_ID } from "utils/Constants";
import { currency, fromDenom, numberPendek, toDenom } from "utils/Helpers"
import { showSimpleModal } from "utils/Modals";
import { querySmartContract } from "utils/RpcHelpers";
import { showLoadingToast, showTxToast } from "utils/Toasts";

export function RewardPage() {
    const { post, address: sender } = useWallet()
    const { stakingAddress, tokenInfo, tokenAddress } = useAsset()
    const [stakingConfig, setStakingConfig] = useState<ConfigResponse>();
    const [rewardInfo, setRewardInfo] = useState<RewardResponse>();
    const [unstakeInfo, setUnstakeInfo] = useState<UnstakeResponse>()

    useEffect(() => {
        const loadRewardEverySeconds = () => {
            if (sender) loadReward()
        };

        const timerInterval = setInterval(loadRewardEverySeconds, 1000);
        loadRewardEverySeconds(); // Initial call to set the initial value

        return () => clearInterval(timerInterval);
    }, [sender]);

    const isValid = () => {
        if (!sender) return "Please connect your wallet first"
        if (!tokenInfo || !stakingAddress) return "Please select an asset"
        if (!rewardInfo || Number(rewardInfo.reward) <= 0) "You have no reward to withdraw"

        return undefined;
    }

    useEffect(() => {
        if (sender) {
            loadConfigStaking()
        }
    }, [sender])

    useEffect(() => {
        if (stakingAddress && sender) loadUnstakeInfo()
    }, [stakingAddress, sender])

    //QUERY
    const loadReward = async () => {
        try {
            const res: RewardResponse = await querySmartContract(stakingAddress!, {
                reward: {
                    staker: sender
                }
            })
            setRewardInfo(res)
        } catch (e) { }
    }

    const loadConfigStaking = async () => {
        try {
            const res: ConfigResponse = await querySmartContract(stakingAddress!, {
                config: {}
            })
            setStakingConfig(res)
        } catch (e) { }
    }

    const loadUnstakeInfo = async () => {
        try {
            const res = await querySmartContract(stakingAddress!, { unstake: { staker: sender } })
            setUnstakeInfo(res)
        } catch (e) { }
    }

    //EXECUTE
    const onWithdraw = async () => {

        let withdrawMsg = {
            withdraw: {
            }
        }

        let executeMsg = new MsgExecuteContract({
            sender: sender!,
            contract: stakingAddress!,
            msg: withdrawMsg,
            funds: []
        })
        const msgs = [executeMsg]

        const task = post({
            msgs,
        })
        const result = await showLoadingToast("Signing transaction", () => task)

        await showTxToast(result)
        loadReward()
    }


    return <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">
            <div className="col-12">
                {
                    isValid() && <div className="alert alert-danger" role="alert">{isValid()}</div>
                }
            </div>
            <div className="col-lg-6 mb-4 order-0">
                <div className="card">
                    <div className="d-flex align-items-end row">
                        <div className="col-sm-7">
                            <div className="card-body">
                                <h5 className="card-title text-primary">Reward 🎉</h5>
                                <div className="d-flex align-items-start justify-content-between mb-1">
                                    <h3 className="card-title">{numberPendek(fromDenom(Number(rewardInfo?.reward ?? "0"), tokenInfo?.decimals ?? 6))} <small>{tokenInfo?.symbol}</small></h3>
                                    <button
                                        onClick={() => showSimpleModal(
                                            "Staked Asset Detail",
                                            <div className="d-flex align-items-center gap-1">
                                                <h6 className="mb-0">{currency(fromDenom(Number(rewardInfo?.reward ?? "0"), tokenInfo?.decimals ?? 6))}</h6>
                                                <span className="text-muted">{tokenInfo?.symbol}</span>
                                            </div>
                                        )}
                                        className="btn btn-sm btn-outline-primary text-nowrap">
                                        Detailed
                                    </button>
                                </div>
                                <p className="mb-4">
                                    The APR is {Number(stakingConfig?.config.apr ?? "0") * 100}%
                                </p>
                                <button
                                    disabled={isValid() != undefined}
                                    onClick={onWithdraw}
                                    className="btn btn-primary deactivate-account">Withdraw</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-sm-12">
                <UnstakeListBox
                    data={unstakeInfo?.unstake} />
            </div>
        </div>
    </div>
}